// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__O10nR","content":"Consent_content__1Nzg4","footer":"Consent_footer__3gnH0"};